(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wujie", [], factory);
	else if(typeof exports === 'object')
		exports["wujie"] = factory();
	else
		root["wujie"] = factory();
})(self, function() {
return 